import { useCallback, useEffect, useRef } from 'react';

import { getIsPostPageBundle } from '@wix/communities-blog-client-common';

import { getIsDesktop, getViewMode } from '../../store/basic-params/basic-params-selectors';
import { useActions, useSelector } from '../runtime-context';

const noop = () => {};

const WindowResizeListener = () => {
  const isDesktop = useSelector(getIsDesktop);
  const isPostPageBundleFromState = useSelector(getIsPostPageBundle);
  const viewMode = useSelector(getViewMode);
  const actions = useActions();
  const postPageResized = actions.postPageResized;
  const resizeComponent = useSelector((_, host) => host.resizeComponent || noop);

  const appWidthRef = useRef(0);

  const handleResize = useCallback(() => {
    if (!isDesktop) {
      return;
    }

    let width = window.innerWidth;

    if (width % 2) {
      width = width - 1;
    }

    if (window.innerWidth !== width) {
      resizeComponent({
        width,
        height: window.innerHeight,
      });
    }

    if (isPostPageBundleFromState && appWidthRef.current !== width) {
      if (postPageResized) {
        postPageResized({ viewMode, width, buildertype: 'desktop' });
      }
      appWidthRef.current = width;
    }
  }, [isDesktop, isPostPageBundleFromState, postPageResized, resizeComponent, viewMode]);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      appWidthRef.current = window.innerWidth;
      window.addEventListener('resize', handleResize, false);

      return () => {
        window.removeEventListener('resize', handleResize, false);
      };
    }
  }, [handleResize]);

  return null;
};

export default WindowResizeListener;
